import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanizeText'
})
export class HumanizeTextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    return value
      .replace(/[_-]/g, ' ')  // Replace underscores and hyphens with spaces
      .replace(/([a-z])([A-Z])/g, '$1 $2')  // Handle camelCase
      .replace(/\b\w/g, (char) => char.toUpperCase())  // Capitalize each word
      .trim();
  }

}
